import styled from 'styled-components';
import { MaskedTextBox } from '@progress/kendo-react-inputs';

export const StyledMaskedTextBox = styled(MaskedTextBox)`
  height: 30px !important;
`;
